module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-creation2@2x.a2d7a970.png" + "?" + Date.now();